@if (searchService.searchResults) {
  <div class="search-results">
    @for (item of searchService.searchResults; track item) {
      <div id="content-list" class="list list-md" >
        <button class="item item-block item-md" text-wrap="" (click)="navigateFromSearchResults(item)">
          <div class="item-inner"  style="margin-top: 5px; padding-bottom: 5px;">
            <div class="input-wrapper" style="width: 100%">
              <div class="list-label label label-md" style="width: 100%;">
                <h2 class="ellipses-label">{{item.product_type_name}}</h2>
              </div>
              <div class="arrow-container">
                <div class="arrow-wrapper">
                  <img src="/assets/img/right-arrow.svg" style="height: 30px;width: 30px" alt="">
                </div>
              </div>
            </div>
            <div class="button-effect"></div>
          </div>
        </button>
      </div>
    }
  </div>
}
